import moboConfigurator from "moboConfigurator";
import { useMemo } from "react";
import { Link, type LinkProps } from "react-router";

type MoboLinkProps = {
  accountId?: number;
} & LinkProps;

export const MoboLink = ({ to, children, accountId, ...props }: MoboLinkProps) => {
  const moboId = useMemo(() => moboConfigurator.getMoboId(), []);
  const id = accountId ?? moboId;
  const hash = id ? `#moboId=${id}` : undefined;

  return (
    <Link to={{ pathname: to as string, hash }} {...props}>
      {children}
    </Link>
  );
};
